[
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "General",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "CALENDAR"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Register",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "CHECKLIST"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Transition",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "CLOCK"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Wellbeing",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "HEART"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Outdoor",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "LEAF"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Music",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "MUSIC_NOTES"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Reading",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "OPEN_BOOK"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "FineMotor",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "PENCIL"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Religious",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "PRAYER_HANDS"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Provision",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "PUZZLE_PIECE"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "BrainBreak",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "RUNNING_MAN"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Assembly",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "SCHOOL"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "FreePlay",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "PLAY_BLOCK"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Talk",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "SPEECH_BUBBLE"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Reward",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "TROPHY"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "Yoga",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "YOGA"
  },
  {
    "EventType": "Activity",
    "Canonical": "FoodBreak",
    "Domain": "Milk",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "BOTTLE"
  },
  {
    "EventType": "Activity",
    "Canonical": "FoodBreak",
    "Domain": "Snack",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "APPLE"
  },
  {
    "EventType": "Activity",
    "Canonical": "Register",
    "Domain": "Morning",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "SUN"
  },
  {
    "EventType": "Activity",
    "Canonical": "Register",
    "Domain": "Register",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": ""
  },
  {
    "EventType": "Fixed",
    "Canonical": "Activities",
    "Domain": "General",
    "DefaultColor": "",
    "BGColour": "",
    "IconId": ""
  },
  {
    "EventType": "Fixed",
    "Canonical": "Break",
    "Domain": "Break",
    "DefaultColor": "",
    "BGColour": "",
    "IconId": ""
  },
  {
    "EventType": "Fixed",
    "Canonical": "EndOfSchool",
    "Domain": "EndOfSchool",
    "DefaultColor": "",
    "BGColour": "",
    "IconId": ""
  },
  {
    "EventType": "Fixed",
    "Canonical": "Lunch",
    "Domain": "Lunch",
    "DefaultColor": "",
    "BGColour": "",
    "IconId": ""
  },
  {
    "EventType": "SchoolClosed",
    "Canonical": "SchoolClosed",
    "Domain": "TeacherTraining",
    "DefaultColor": "#3743bd",
    "BGColour": "#f3f3f3",
    "IconId": "GRAD_HAT"
  },
  {
    "EventType": "SchoolClosed",
    "Canonical": "SchoolClosed",
    "Domain": "SchoolClosed",
    "DefaultColor": "#3743bd",
    "BGColour": "#f3f3f3",
    "IconId": "NO_SCHOOL"
  },
  {
    "EventType": "SchoolClosed",
    "Canonical": "SchoolClosed",
    "Domain": "Holiday",
    "DefaultColor": "#3743bd",
    "BGColour": "#f3f3f3",
    "IconId": "TEA_MUG"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "Activities",
    "Domain": "Assembly",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "SCHOOL"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "English",
    "Domain": "Spelling",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "ABC_CHECK"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Trip",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "SCHOOL_BUS"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Party",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "BALLOON"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Photo",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "CAMERA"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Movie",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "FILM_CAMERA"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Fire",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "FIRE"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Talk",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "SPEECH_BUBBLE"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "SpecialEvent",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "STAR"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "SportsDay",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "TORCH"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Christmas",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "STAR"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Leavers",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "GRAD_HAT"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Transition",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "GRAD_HAT"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Performance",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "DRAMA_MASK"
  },
  {
    "EventType": "SpecialEvent",
    "Canonical": "SpecialEvent",
    "Domain": "Fair",
    "DefaultColor": "#3ad0c6",
    "BGColour": "#eefefd",
    "IconId": "BALLOON"
  },
  {
    "EventType": "Subject",
    "Canonical": "ArtDesign",
    "Domain": "Art",
    "DefaultColor": "#b97ef9",
    "BGColour": "",
    "IconId": "PAINT_BRUSH"
  },
  {
    "EventType": "Subject",
    "Canonical": "Computing",
    "Domain": "Computing",
    "DefaultColor": "#b0b0b0",
    "BGColour": "",
    "IconId": "TECH_CHIP"
  },
  {
    "EventType": "Subject",
    "Canonical": "DesignTechnology",
    "Domain": "DesignTechnology",
    "DefaultColor": "#3ed4f5",
    "BGColour": "",
    "IconId": "RULER_PENCIL"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Drama",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "DRAMA_MASK"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "English",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "EN"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Spelling",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "ABC_CHECK"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Writing",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "PENCIL"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Grammar",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "INTERROBANG"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Handwriting",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "PENCIL_LINE"
  },
  {
    "EventType": "Subject",
    "Canonical": "English",
    "Domain": "Oracy",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "SPEECH_BUBBLES"
  },
  {
    "EventType": "Subject",
    "Canonical": "ExpressiveArts",
    "Domain": "ExpressiveArts",
    "DefaultColor": "#b97ef9",
    "BGColour": "",
    "IconId": "PAINT_BRUSH"
  },
  {
    "EventType": "Subject",
    "Canonical": "Geography",
    "Domain": "Geography",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "GLOBE"
  },
  {
    "EventType": "Subject",
    "Canonical": "History",
    "Domain": "History",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "SCROLL"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "French",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "EIFFEL"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "German",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "PRETZEL"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "Italian",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "LEANINGTOWER"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "Mandarin",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "CHINESE_WRITING"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "Arabic",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "ARABIC_WRITING"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "Spanish",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "SPAIN_FAN"
  },
  {
    "EventType": "Subject",
    "Canonical": "Languages",
    "Domain": "Languages",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "SPEECH_BUBBLE"
  },
  {
    "EventType": "Subject",
    "Canonical": "Mathematics",
    "Domain": "TimesTables",
    "DefaultColor": "#4d98f9",
    "BGColour": "",
    "IconId": "MULTIPLICATION"
  },
  {
    "EventType": "Subject",
    "Canonical": "Mathematics",
    "Domain": "Mathematics",
    "DefaultColor": "#4d98f9",
    "BGColour": "",
    "IconId": "HASH"
  },
  {
    "EventType": "Subject",
    "Canonical": "Music",
    "Domain": "Music",
    "DefaultColor": "#b97ef9",
    "BGColour": "",
    "IconId": "MUSIC_NOTES"
  },
  {
    "EventType": "Subject",
    "Canonical": "PersonalSocial",
    "Domain": "PersonalSocial",
    "DefaultColor": "#ff99d8",
    "BGColour": "",
    "IconId": "SMALL_MAN"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "PhysicalEd",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "BALL"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "OAA",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "COMPASS"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "Dance",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "DANCE"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "BrainBreak",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "SMALL_MAN"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "Athletics",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "STOPWATCH"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "Gymnastics",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "HANDSTAND"
  },
  {
    "EventType": "Subject",
    "Canonical": "PhysicalEd",
    "Domain": "Swim",
    "DefaultColor": "#555555",
    "BGColour": "",
    "IconId": "SWIM"
  },
  {
    "EventType": "Subject",
    "Canonical": "Reading",
    "Domain": "Phonics",
    "DefaultColor": "#ef4f51",
    "BGColour": "",
    "IconId": "ABC_STACKED"
  },
  {
    "EventType": "Subject",
    "Canonical": "Reading",
    "Domain": "Comprehension",
    "DefaultColor": "#ef4f51",
    "BGColour": "",
    "IconId": "OPEN_BOOK"
  },
  {
    "EventType": "Subject",
    "Canonical": "Reading",
    "Domain": "Reading",
    "DefaultColor": "#ef4f51",
    "BGColour": "",
    "IconId": "READ_PERSON"
  },
  {
    "EventType": "Subject",
    "Canonical": "Reading",
    "Domain": "Story",
    "DefaultColor": "#ef4f51",
    "BGColour": "",
    "IconId": "READ_PERSON"
  },
  {
    "EventType": "Subject",
    "Canonical": "Reading",
    "Domain": "RWI",
    "DefaultColor": "#ef4f51",
    "BGColour": "",
    "IconId": "RWI"
  },
  {
    "EventType": "Subject",
    "Canonical": "ReligiousEd",
    "Domain": "ReligiousEd",
    "DefaultColor": "#ff99d8",
    "BGColour": "",
    "IconId": "PRAYER_HANDS"
  },
  {
    "EventType": "Subject",
    "Canonical": "Science",
    "Domain": "Science",
    "DefaultColor": "#57cc75",
    "BGColour": "",
    "IconId": "SCIENCE_ATOM"
  },
  {
    "EventType": "Subject",
    "Canonical": "UnderstandingWorld",
    "Domain": "UnderstandingWorld",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "GLOBE"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "CatchUp",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "CLOCK"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Intervention",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "FLAG"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionMaths",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "HASH"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionSEMH",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "HEART"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Art",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "PAINT_BRUSH"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Provision",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "PUZZLE_PIECE"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionReading",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "READ_PERSON"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "ProjectWork",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "SIGNPOST"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionSpeech",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "SPEECH_BUBBLES"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Foundation",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "SMILING_FACE"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Independent",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "STATIONERY"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Outdoor",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "TREE"
  },
  {
    "EventType": "SubjectMisc",
    "Canonical": "SubjectMisc",
    "Domain": "Reward",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "TROPHY"
  },
  {
    "EventType": "Subject",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionSEMH",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "HEART"
  },
  {
    "EventType": "Subject",
    "Canonical": "SubjectMisc",
    "Domain": "InterventionReading",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "READ_PERSON"
  },
  {
    "EventType": "TeacherTime",
    "Canonical": "TeacherTime",
    "Domain": "TeacherTime",
    "DefaultColor": "#3743bd",
    "BGColour": "#edeeff",
    "IconId": "BRIEFCASE"
  },
  {
    "EventType": "TeacherTime",
    "Canonical": "TeacherTime",
    "Domain": "Training",
    "DefaultColor": "#3743bd",
    "BGColour": "#edeeff",
    "IconId": "BRIEFCASE"
  },
  {
    "EventType": "Test",
    "Canonical": "English",
    "Domain": "Test",
    "DefaultColor": "#febf00",
    "BGColour": "",
    "IconId": "TEST_PAPER"
  },
  {
    "EventType": "Test",
    "Canonical": "Languages",
    "Domain": "Test",
    "DefaultColor": "#ff7b00",
    "BGColour": "",
    "IconId": "TEST_PAPER"
  },
  {
    "EventType": "Test",
    "Canonical": "Mathematics",
    "Domain": "Test",
    "DefaultColor": "#4d98f9",
    "BGColour": "",
    "IconId": "TEST_PAPER"
  },
  {
    "EventType": "Test",
    "Canonical": "SubjectMisc",
    "Domain": "Test",
    "DefaultColor": "#3ad0c6",
    "BGColour": "",
    "IconId": "TEST_PAPER"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "ExtracurricularClub",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "SPARKLES"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "HomeworkClub",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "STATIONERY"
  },
  {
    "EventType": "Activity",
    "Canonical": "Activities",
    "Domain": "SportsClub",
    "DefaultColor": "#3743bd",
    "BGColour": "",
    "IconId": "BALL"
  },
  {
    "EventType": "TeacherTime",
    "Canonical": "TeacherTime",
    "Domain": "Meeting",
    "DefaultColor": "#3743bd",
    "BGColour": "#edeeff",
    "IconId": "BRIEFCASE"
  },
  {
    "EventType": "TeacherTime",
    "Canonical": "TeacherTime",
    "Domain": "ParentWorkshop",
    "DefaultColor": "#3743bd",
    "BGColour": "#edeeff",
    "IconId": "BRIEFCASE"
  }
]
